import { Loader2 } from "lucide-react";

const LoadingFallback = () => (
    <div className="flex h-screen w-full items-center justify-center">
      <Loader2 className="h-6 w-6 animate-spin" />
    </div>
  );

  export default LoadingFallback;